import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];
  static values = {
    active: {
      type: Boolean,
      default: false,
    },
    on: String,
    off: String,
  };

  declare activeValue: boolean;
  declare onValue: string;
  declare offValue: string;
  declare buttonTargets: Array<HTMLButtonElement>;
  private handleUpdate = this.update.bind(this);

  connect() {
    this.bindMethods();
  }

  disconnect() {
    this.unbindMethods();
  }

  bindMethods() {
    window.addEventListener("save:toggled", this.handleUpdate);
  }

  unbindMethods() {
    window.removeEventListener("save:toggled", this.handleUpdate);
  }

  update() {
    this.activeValue = !this.activeValue;
    this.buttonTargets.forEach((target: HTMLButtonElement) => {
      this.updateButton(target);
      const button = this.getButtonText(target);
      if (button)
        button.textContent = this.activeValue ? this.onValue : this.offValue;
    });
  }

  getButtonText(target: HTMLButtonElement) {
    return target.querySelector("span");
  }

  updateButton(el: HTMLButtonElement) {
    el.dataset.status = `${this.activeValue}`;
  }
}
